import {
  DEBUG_PANEL_DISABLED_VALUE,
  DEBUG_PANEL_STORAGE_KEY
} from './constants'

export function isDebugPanelDisabled(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return (
      window.localStorage.getItem(DEBUG_PANEL_STORAGE_KEY) ===
      DEBUG_PANEL_DISABLED_VALUE
    )
  } catch {
    return false
  }
}

export function disableDebugPanel(): void {
  try {
    window.localStorage.setItem(
      DEBUG_PANEL_STORAGE_KEY,
      DEBUG_PANEL_DISABLED_VALUE
    )
  } catch {
    /* ignore quota / private mode */
  }
}

export function enableDebugPanel(): void {
  try {
    window.localStorage.removeItem(DEBUG_PANEL_STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
